import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const AssetFormAccountant = ({
  accounts = [],
  catalogs = {},
  depreciations = [],
  errors = {},
  handleValueChange = () => {},
  isLoading = false,
  isSubmitted = false,
  subaccounts = [],
  t = () => {},
  values = {},
}) => {

  const handleUsefulLifeOriginalChange = (event) => {
    const { name, value } = event.target;

    let formattedValue = value.replace(/\D/g, '');

    if (formattedValue.length > 6) {
      formattedValue = formattedValue.slice(0, 6);
    }

    if (formattedValue.length > 3) {
      formattedValue = formattedValue.slice(0, 3) + '/' + formattedValue.slice(3);
    }

    handleValueChange({ target: { name, value: formattedValue } });
  };

  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.accountant')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._account) || {}}
          isLoading={isLoading}
          name={'account'}
          label={t('assets.fields.account')}
          handleChange={handleValueChange}
          t={t}
          value={values._account && values._account.id}
        >
          {accounts &&
            accounts
              .filter((element) => element != null)
              .map((account) => (
                <option value={account.id} key={account.id}>
                  {account.key} - {account.name}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._subaccount) || {}}
          isLoading={isLoading}
          name={'subaccount'}
          label={t('assets.fields.subaccount')}
          handleChange={handleValueChange}
          t={t}
          value={values._subaccount && values._subaccount.id}
        >
          {subaccounts &&
            subaccounts
              .filter((element) => element != null)
              .map((subaccount) => (
                <option value={subaccount.id} key={subaccount.id}>
                  {subaccount.key} - {subaccount.name}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldDate
          error={(isSubmitted && errors.startDate) || {}}
          name={'startDate'}
          label={t('assets.fields.startDate')}
          handleChange={handleValueChange}
          t={t}
          value={values.startDate}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors.status) || {}}
          isLoading={isLoading}
          name={'status'}
          label={t('assets.fields.status')}
          handleChange={handleValueChange}
          t={t}
          value={values._status && values._status.id}
        >
          {catalogs.status &&
            catalogs.status
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.value)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._account) || {}}
          isLoading={isLoading}
          name={'financialDepreciation'}
          label={t('assets.fields.financialDepreciation')}
          handleChange={handleValueChange}
          t={t}
          value={(values._financialDepreciation && values._financialDepreciation.id) || ''}
        >
          {depreciations &&
            depreciations
              .filter((element) => element != null)
              .map((depreciation) => (
                <option value={depreciation.id} key={depreciation.id}>
                  {depreciation.key} - {depreciation.name}
                </option>
              ))}
        </Form.FieldSelect>
      </div>

      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._account) || {}}
          isLoading={isLoading}
          name={'fiscalDepreciation'}
          label={t('assets.fields.fiscalDepreciation')}
          handleChange={handleValueChange}
          t={t}
          value={values._fiscalDepreciation && values._fiscalDepreciation.id}
        >
          {depreciations &&
            depreciations
              .filter((element) => element != null)
              .map((depreciation) => (
                <option value={depreciation.id} key={depreciation.id}>
                  {depreciation.key} - {depreciation.name}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.usefulLifeOriginal) || {}}
          name={'usefulLifeOriginal'}
          label={t('assets.fields.usefulLifeOriginal')}
          handleChange={handleUsefulLifeOriginalChange}
          t={t}
          value={values.usefulLifeOriginal}
          placeholder="aaa/mmm"
        />
      </div>
    </div>
  );
};

export default translate()(AssetFormAccountant);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormAccountant.js